import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Spinner, Box } from '@chakra-ui/react';

/**
 * Route guard for the Agent Studio (/assistants).
 *
 * Grants access ONLY to users with users/{uid}.agentStudioEnabled === true
 * (merged into currentUser by AuthContext.getRole). Deliberately NO SuperAdmin
 * bypass — the studio ships hidden from everyone, including other admins,
 * until each user is explicitly flagged. The backend callables enforce the
 * same flag, so this guard is UX, not security.
 *
 * `component` must be destructured out and rendered inside `render`: if it
 * were spread onto <Route> alongside `render`, React Router would use it
 * directly and skip the guard entirely (component takes precedence).
 */
const AgentStudioRoute = ({ children, component: Component, ...rest }) => {
  const { currentUser, loading } = useAuth();

  if (loading) {
    return (
      <Box w="100%" h="100vh" display="flex" justifyContent="center" alignItems="center">
        <Spinner size="xl" />
      </Box>
    );
  }

  return (
    <Route
      {...rest}
      render={(routeProps) =>
        currentUser && currentUser.agentStudioEnabled === true ? (
          Component ? <Component {...routeProps} /> : children
        ) : (
          <Redirect
            to={{
              pathname: '/',
              state: { from: routeProps.location },
            }}
          />
        )
      }
    />
  );
};

export default AgentStudioRoute;
